import { FC } from 'react';
import { Grid, IconButton, Tooltip, Button, Stack } from '@mui/material';
import { Download, Refresh } from '@mui/icons-material';
import { usePerformance } from '../performance.context';
import { useTranslation } from 'src/hooks/useTranslationHook';

interface PerformanceHeaderProps {
  onExport: (format: 'pdf' | 'excel') => Promise<void>;
}

const PerformanceHeader: FC<PerformanceHeaderProps> = ({ onExport }) => {
  const { state } = usePerformance();
  const { translateText } = useTranslation();

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleExport = async () => {
    await onExport('excel');
  };

  return (
    <Grid
      item
      xs={12}
      sx={{
        display: 'flex',
        justifyContent: { xs: 'center', sm: 'end' },
        alignItems: 'center',
        mb: { xs: 2, sm: 3 },
        px: { xs: 0, sm: 3 },
      }}
      data-testid="performance-header"
    >
      <Stack 
        direction={{ xs: 'column', sm: 'row' }} 
        spacing={{ xs: 1, sm: 2 }} 
        alignItems="center"
        sx={{ width: { xs: '100%', sm: 'auto' } }}
      >
        <Tooltip title={translateText('analytics.performance.refreshData')}>
          <IconButton
            color="primary"
            onClick={handleRefresh}
            disabled={state.isLoading}
            sx={{
              minHeight: { xs: '44px', sm: 'auto' },
              minWidth: { xs: '44px', sm: 'auto' },
            }}
          >
            <Refresh />
          </IconButton>
        </Tooltip>

        <Tooltip title={translateText('analytics.performance.exportData')}>
          <Button
            variant="outlined"
            startIcon={<Download />}
            onClick={handleExport}
            disabled={state.isLoading}
            size="small"
            fullWidth={false}
            sx={{
              minHeight: { xs: '44px', sm: '36px' },
              fontSize: { xs: '16px', sm: '14px' },
              width: { xs: '100%', sm: 'auto' },
            }}
          >
            {translateText('analytics.performance.export')}
          </Button>
        </Tooltip>
      </Stack>
    </Grid>
  );
};

export default PerformanceHeader;
